import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cardImg: {
        display: "flex",
        objectFit: "cover",
        zIndex: 1,
        position: 'relative',
        background: theme.palette.common.white,
        width: "70px",
        height: "70px",
        borderRadius: "5px",
        boxShadow: '0px 1.9698734283447266px 3.939746856689453px 0px #00000026'
    },
    card: {
        padding: 5,
        width: '100%',
        background: '#F8F8F8',
        borderRadius: '15px',
    },
    gridContainer: {
        '& p': {
            fontSize: 13
        }
    },
    nome: {
        borderBottom: '2px solid #E6E6E6',
        [theme.breakpoints.up('md')]: {
            borderBottom: 'none'
        }
    },
    editIcon: {
        borderLeft: '2px solid #E6E6E6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 10px',
        margin: '10px 0',
    }, 
}))